import React from 'react'
import Subheader from '../../../component/Subheader'
import OtherRoom from '../../RoomDetail/OtherRoom';
import RoomBanner from '../../RoomDetail/RoomBanner';
import RoomQuote from '../../RoomDetail/RoomQuote';
import RoomCount from '../../RoomDetail/RoomCount';
import RoomGallery from '../../RoomDetail/RoomGallery';
import RoomEquipment from '../../RoomDetail/RoomEquipment';
import RoomBook from '../../RoomDetail/RoomBook';

export default function RishikeshFamilycottages() {
    const heading = "Ganga Suite";

    const subheadData = {
        heading: (
                    <>
                    <span className="sr-only">Rishikesh Room</span> {heading}
                    </>
                ),
        breadcrumb: [
            {
                slug: "/resort-de-coracao-rishikesh/room-listing",
                name: (
                        <>
                        <span className="sr-only">{heading}</span> Rooms
                        </>
                    ),
            },
            {
                slug: "",
                name: "Ganga Suite",
            },
        ]
    }

    const roomBanner = {
        image: "/image/rishikesh-ganga-suite-detail.webp",
    };

    const roomQuote = {
        content: "Featuring a Private Balcony Ganga View, the Ganga Suite offers a luxury escape where you can unwind while embracing the serene atmosphere of the city. Whether you're celebrating a special occasion or simply treating yourself to a luxurious getaway, this suite promises comfort, privacy, and an unforgettable stay.",
    };

    const roomCount = {
        bedroom: "1",
        bedsize: "1 King",
        area: "30",
        bathroom: "1",
        guest: "3",
        balcony: "1"
    };

    const roomGallery = [
        { image: "/image/rishikesh-ganga-suite-gallery-1.webp" },
        { image: "/image/rishikesh-ganga-suite-gallery-2.webp" },
        { image: "/image/rishikesh-ganga-suite-gallery-3.webp" },
        { image: "/image/rishikesh-ganga-suite-gallery-4.webp" },
        // { image: "/image/rishikesh-ganga-suite-gallery-5.webp" },
    ];

    const roomEquipment = {
        description: "Created with your comfort in mind, this room provides an inviting space complemented by essential amenities and modern conveniences.",
        equipment: [
        [
            "Premium Pocketed Spring Mattress",
            "Air Conditioning",
            "Complimentary High-Speed Wi-Fi",
            "Smart TV for Entertainment",
        ],
        [
            "Tea & Coffee Maker with Daily Replenishment",
            "Mini Bar for Refreshments",
            "Electronic In-Room Safe",
            "Writing Desk with Comfortable Chair",
        ],
        [
            "Hydropneumatic Shower with 24-Hour Hot Water",
            "Soft Cotton Linens and Plush Duvet",
            "Iron & Ironing Board",
            "Bathrobe & Slippers",
        ]
    ]
    };


    const roomBook = {
        location: "Rishikesh",
        title: "Ganga Suite",
        desc: "Experience an elevated stay in the Ganga Suite at De Coracao Rishikesh, where comfort meets serene surroundings. With a private balcony, spacious interiors, and thoughtful amenities, it is an ideal choice for relaxing escapes, special occasions, and memorable moments in Rishikesh.",
        details: [
            "1 King Size Beds",
            "Up to 3 Guests",
            "30 sq.mt"
        ],
        enquireLink: "/contact-us",
        bookLink: "https://www.swiftbook.io/inst/#/home?propertyId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU=&JDRN=Y&RoomID=255031,255032,255033,255034,255035&ap=1&gsId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU="
    };


    const otherRoom = {
        slides: [
            {
                title: 'Super Deluxe',
                bg: '/image/rishikesh-super-deluxe-inner-img.webp',
                slug: '/resort-de-coracao-rishikesh/super-deluxe',
                details: [
                    "1 King Size Bed",
                    "Up to 3 Guests",
                    "26 sq.mt",
                ],
            },

            {
                title: 'Suite',
                bg: '/image/rishikesh-suite-inner-img.webp',
                slug: '/resort-de-coracao-rishikesh/suite',
                details: [
                    "1 King Size Bed",
                    "Up to 3 Guests",
                    "33 sq.mt",
                ],
            },

            {
                title: 'Premium Suite',
                bg: '/image/rishikesh-premium-suite-inner.webp',
                slug: '/resort-de-coracao-rishikesh/premium-suite',
                details: [
                    "1 King Size Bed",
                    "Up to 3 Guests",
                    "30 sq.mt",
                ],
            },

           
            {
                title: 'Deluxe',
                bg: '/image/rishikesh-deluxe-inner-img.webp',
                slug: '/resort-de-coracao-rishikesh/deluxe',
                details: [
                    "1 King Size Bed",
                    "Up to 2 Guests",
                    "21 sq.mt",
                ],
            },
        ],

        allRoom: { link: "/resort-de-coracao-rishikesh/room-listing" }
    }

    return (
        <>  
            <Subheader subheadData={subheadData} />
            <RoomBanner roomBanner={roomBanner} />
            <RoomQuote roomQuote={roomQuote} />
            <RoomCount roomCount={roomCount} />
            <RoomGallery roomGallery={roomGallery} />
            <RoomEquipment roomEquipment={roomEquipment} />
            <RoomBook roomBook={roomBook} />
            <OtherRoom otherRoom={otherRoom} roomTitle={`${roomBook.location} ${subheadData.heading}`}/>
        </>
    )
}
